import { render, staticRenderFns } from "./address-change-requests-icon.vue?vue&type=template&id=630be71e"
import script from "./address-change-requests-icon.vue?vue&type=script&lang=js"
export * from "./address-change-requests-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports